import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, TextField, Autocomplete } from '@mui/material';
import { Search, Close } from '@mui/icons-material';
import theme from '../../theme';
import { useUserStore } from '../../stores/userStore';
import { trackSearch } from '../../lib/gaEvents';

const TabletSearchBar = ({ isOpen, onClose, pageType }) => {
  const [searchValue, setSearchValue] = useState('');
  const navigate = useNavigate();
  const user = useUserStore((state) => state.user);
  useEffect(() => {
    if (isOpen) {
      setSearchValue('');
    }
  }, [isOpen]);

  // 스크롤 잠금: body fixed 대신 scrollTo + 스크롤 이벤트 차단
  useEffect(() => {
    if (!isOpen) return;

    const preventScroll = (e) => e.preventDefault();

    document.addEventListener('touchmove', preventScroll, { passive: false });
    document.addEventListener('wheel', preventScroll, { passive: false });

    return () => {
      document.removeEventListener('touchmove', preventScroll);
      document.removeEventListener('wheel', preventScroll);
    };
  }, [isOpen]);

  const handleSearch = (e) => {
    e.preventDefault();
    const trimmed = searchValue.trim();
    if (trimmed) {
      trackSearch({ searchTerm: trimmed, pageType }, user);
      navigate(`/search/summary?q=${encodeURIComponent(trimmed)}`);
      setSearchValue('');
      onClose();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch(e);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      {/* 검색창 */}
      <Box
        sx={{
          borderTop: `1px solid ${theme.palette.grey.line}`,
          height: 72,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.palette.surface.main,
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            width: 510,
            height: 40,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            px: 1.5,
            backgroundColor: theme.palette.surface.main,
            border: `1px solid ${theme.palette.grey.line}`,
            borderRadius: 1,
          }}
        >
          <Search sx={{ width: 16, height: 16, color: theme.palette.black[1], flexShrink: 0 }} />
          <Autocomplete
            freeSolo
            options={[]}
            sx={{ flex: 1 }}
            inputValue={searchValue}
            onInputChange={(_, newInputValue) => {
              setSearchValue(newInputValue);
            }}
            onSubmit={handleSearch}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                placeholder="앨범, 아티스트 등 검색"
                autoFocus
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                  sx: {
                    fontSize: 14,
                    color: theme.palette.black[2],
                  },
                  onKeyPress: handleKeyPress,
                }}
              />
            )}
            clearIcon={
              <Close
                sx={{
                  width: 16,
                  height: 16,
                  backgroundColor: theme.palette.black[1],
                  borderRadius: '50px',
                  color: theme.palette.common.white,
                }}
              />
            }
          />
        </Box>
      </Box>

      {/* 오버레이 */}
      <Box
        onClick={onClose}
        sx={{
          position: 'fixed',
          top: 132, // 헤더(60) + 검색창(72)
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 0,
        }}
      />
    </>
  );
};

export default TabletSearchBar;
